import { AgentBridgeProvider } from "./app/AgentBridge";
import { AppShell } from "./app/AppShell";
import { LoginScreen } from "./auth/LoginScreen";
import { useAuth } from "./auth/useAuth";

export function App() {
  const { state, login, logout } = useAuth();

  if (state.kind === "loading") {
    return <div className="boot-screen">Lädt…</div>;
  }
  if (state.kind === "needs_login") {
    return <LoginScreen onSubmit={login} />;
  }
  return (
    <AgentBridgeProvider enabled={state.kind === "authenticated" || state.kind === "open"}>
      <AppShell onLogout={logout} showLogout={state.kind === "authenticated"} />
    </AgentBridgeProvider>
  );
}
